$(function () {
  var host = "https://dip.sylvoxtv.com/api/api";
  const passwordkey = "my-secret-key";
  const netAddress = {
    'US':'com',
    'EU':'eu',
    'AU':'com.au',
    'CA':'ca',
    'UK':'uk'
  }
  var addressTag='US'
  // 动态渲染select option
  var selectList = [];
  function getSelectList() {
    $.ajax({
      url: host + "/platform",
      method: "GET",
      contentType: "JSONP",
      data: {},
      success: function (res) {
        if (res.Code == 0) {
          $(".el-select__list").empty();
          if (res.Data.length == 0) {
            $(".el-select__list").append(
              `<li class="el-select__item el-select-disabled" data-value="">No Data</li>`
            );
            return;
          }
          selectList = res.Data;
          res.Data.forEach(function (opt) {
            $(".el-select__list").append(
              `<li class="el-select__item" data-value="${opt.id}">${opt.platformUSName}</li>`
            );
          });
        } else {
          $(".el-select__list").empty();
          $(".el-select__list").append(
            `<li class="el-select__item" data-value="">No Data</li>`
          );
          showToast(res.Msg);
        }
      },
      error: function (error) {
        $(".el-select__list").append(
          `<li class="el-select__item" data-value="">No Data</li>`
        );
        showToast("Error Failed");
      },
      complete: function (params) {
        $(".el-select__editor").attr("readonly", false);
        $("#selectLoading").removeClass("select-loading-show");
      },
    });
  }
  $("#serialInputLoading").hide();
  getSelectList();
  // 建议列表数据
  var suggestions = [
    "United States of America",
    "Germany",
    "United Kingdom",
    "Europe",
    "Canada",
    "Australia"
  ];
  var $suggestList = $("#suggestList");
  $("#country_region").on("focus", function () {
    $suggestList.html(
      suggestions
        .map(function (item) {
          return "<li>" + item + "</li>";
        })
        .join("")
    );
    $suggestList.addClass("el-select__dropdown--visible");
  });
  $("#country_region").on("input", function () {
    var val = $(this).val().toLowerCase();
    var filtered = suggestions.filter(function (item) {
      var itemVal = item.toLowerCase();
      return itemVal.indexOf(val) !== -1;
    });
    if (filtered.length > 0) {
      $suggestList
        .html(
          filtered
            .map(function (item) {
              return "<li>" + item + "</li>";
            })
            .join("")
        )
        .addClass("el-select__dropdown--visible");
    } else {
      $suggestList.removeClass("el-select__dropdown--visible");
    }
  });
  $("#country_region").on("blur", function () {
    $suggestList.removeClass("el-select__dropdown--visible");
  });
  $suggestList.on("mousedown", "li", function () {
    $("#country_region").val($(this).text());
    $suggestList.removeClass("el-select__dropdown--visible");
  });
  // 自定义多图上传按钮逻辑
  $("#multiImgPreview").on("click", "#multiUploadBtn", function () {
    if (filesList.length >= 2) {
      showToast("You can only upload up to 2 images");
      return;
    }
    $("#order_screenshot").click();
  });
  // 多图预览渲染时保留上传按钮
  function renderMultiImgPreview() {
    var $preview = $("#multiImgPreview");
    $preview.empty();
    multiImgData.forEach(function (data, i) {
      var $box = $('<div class="img-thumb-box"></div>');
      var $img = $("<img>")
        .attr("src", data)
        .css({
          width: "80px",
          height: "80px",
          objectFit: "cover",
          borderRadius: "4px",
          cursor: "pointer",
          border: "1px solid #eee",
        })
        .attr("data-big", data)
        .attr("title", "review")
        .attr("data-idx", i);
      var $del = $(
        '<button class="img-thumb-del" title="delete">×</button>'
      ).attr("data-idx", i);
      $box.append($img).append($del);
      $preview.append($box);
    });
    $preview.append(
      '<div class="multi-upload-btn" id="multiUploadBtn"><svg t="1747823126898" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1493" width="32" height="32"><path d="M1020.192947 541.265648h-460.281325v482.734352h-78.889013V541.265648H3.761254v-78.877563h477.307154V0h78.889013v462.388085h460.281325v78.877563z" fill="#707070" p-id="1494"></path></svg></div>'
    );
  }
  // 多图片上传及预览
  var multiImgData = [];
  var filesList = [];
  $("#order_screenshot").on("change", function (e) {
    var files = e.target.files;
    if (files.length === 0) return;
    var totalLength = files.length + filesList.length
    if (totalLength  > 2) {
      showToast("You can only upload up to 2 images");
      return;
    }
    Array.from(files).forEach(function (file, idx) {
      if (file.type.startsWith("image/")) {
        filesList.push(file);
        var reader = new FileReader();
        reader.onload = function (evt) {
          multiImgData.push(evt.target.result);
          renderMultiImgPreview();
        };
        reader.readAsDataURL(file);
      }
    });
    $(this).val("");
    removeClass("#multiUploadBtn", "OrderScreenshot");
  });
  // 缩略图点击预览大图
  $("#multiImgPreview").on("click", "img", function (e) {
    if ($(e.target).hasClass("img-thumb-del")) return;
    var src = $(this).attr("data-big");
    $("#imgViewBig").attr("src", src);
    $("#imgViewModal").fadeIn(120);
  });
  // 删除图片
  $("#multiImgPreview").on("click", ".img-thumb-del", function (e) {
    e.stopPropagation();
    var idx = $(this).siblings("img").attr("data-idx");
    multiImgData.splice(idx, 1);
    filesList.splice(idx, 1);
    renderMultiImgPreview();
  });
  $("#imgViewClose").on("click", function () {
    $("#imgViewModal").fadeOut(120);
  });
  // 移除错误样式
  $("#email").on("change", function () {
    removeClass("#email", "Email");
  });
  $("#order_id").on("change", function () {
    removeClass("#order_id", "OrderId");
  });
  $("#serial_number").on("change", function () {
    removeClass("#serial_number", "SerialNumber");
  });
  $("#password").on("change", function () {
    removeClass("#password", "");
  });
  function removeClass(className, labelName) {
    $(className).removeClass("error-input");
    $('label[for="' + labelName + '"]')
      .find("span")
      .first()
      .removeClass("error-label");
  }
  var submitBoolen = false;
  // 提交按钮
  $("#submitBtn").on("click", function () {
    if (submitBoolen) {
      return showToast("Requesting...");
    }
    var hasError = false;
    var requiredFields = [
      { input: "#formSelect", label: 'label[for="PurchaseChannel"]' },
      { input: "#email", label: 'label[for="Email"] ' },
      { input: "#order_id", label: 'label[for="OrderId"] ' },
      { input: "#serial_number", label: 'label[for="SerialNumber"] ' },
    ];
    requiredFields.forEach(function (f) {
      var $input = $(f.input);
      var $label = $(f.label).find("span").first();
      var val = $input.val();
      var empty = !val || (f.input === "#mySelect" && val === "");
      if (empty) {
        if(f.input == '#formSelect'){
          $('.el-select__input').addClass("error-input");
        }else{
          $input.addClass("error-input");
        }
        
        $label.addClass("error-label");
        hasError = true;
      }
    });
    if (multiImgData.length === 0) {
      $("#multiUploadBtn").addClass("error-input");
      $('label[for="OrderScreenshot"]')
        .find("span")
        .first()
        .addClass("error-label");
      hasError = true;
    }
    if (hasError) {
      showToast("Incomplete required fields");
      return;
    }

    var terms_Privacy = $("#terms_Privacy").prop("checked");
    var subcribe = $("#subcribe").prop("checked");
    if (!terms_Privacy) {
      $(".terms_Privacy").addClass("shake");
      setTimeout(function () {
        $(".terms_Privacy").removeClass("shake");
      }, 300);
      return;
    }
    if (!subcribe) {
      $(".subcribe").addClass("shake");
      setTimeout(function () {
        $(".subcribe").removeClass("shake");
      }, 400);
      return;
    }
    $("#submitBtn").prop("disabled", true).html("Submitting...");
    $("#cancelBtn").prop("disabled", true);
    showFullscreenLoading();
    submitBoolen = true;
    // 发送请求
    $.ajax({
      url: host + "/isRegister?userEmail=" + $("#email").val(),
      method: "GET",
      processData: false,
      contentType: false,
      success: function (res) {
        if (res.Code == 0) {
          if(res.data && res.data.area) addressTag = res.data.area
          $("#ModalText").html(
            "<div>  Warm reminder,you device warrenty activation information will be entered into our warranty system</div><div>  protecting your right. Thanks you for your participation submission.</div>"
          );
          $("#modalOk").attr("data-action", "submit");
          $("#myModal").fadeIn(150);
        } else if (res.Code == 404) {
          var userEmail = ''
          const [username, domain] = $("#email").val().split('@');
          const domainParts = domain.split('.');
          if(domainParts.length < 2){
            userEmail= $("#email").val();
          } else{
            domainParts[0] = '***';
            userEmail = `${username}@${domainParts.join('.')}`
          }
          $("#ModalText")
            .html(`  In order to facilitate the viewing of information after your device is activated, the current reference email address is the email address you submitted. It is currently detected that you have not registered a brand account. Please create a login password below.`);
          var input = `
          <div class="form-group">
            <label class="form_Title email_form_label">
              <span style="color:#666;" class="email_info">Email：${userEmail}<span class="tooltip-email-info">${$("#email").val()}</span></span>
            </label>
            <div><span class="password-title">Create Pwd：</span><input type="password" id="password" class="form-input" name="password" autocomplete="off"></div>
          </div>`;
          $("#createAccount").html(input);
          $("#modalOk").attr("data-action", "register");
          $("#myModal").fadeIn(150);
        } else {
          showToast(res.Msg);
        }
      },
      error: function (xhr) {
        showToast("Submit failed");
      },
      complete: function () {
        submitBoolen = false;
        $("#submitBtn").prop("disabled", false).html("Submit");
        $("#cancelBtn").prop("disabled", false);
        hideFullscreenLoading();
      },
    });
  });
  // 取消按钮
  $("#cancelBtn").on("click", function () {
    $("#ModalText").html(
      "  Warm reminder:Device warranty activation can enjoy the brand's warranty service certificate, are you sure to cancel?"
    );
    $("#modalOk").attr("data-action", "cancel");
    $("#myModal").fadeIn(150);
  });
  // 弹窗逻辑
  $("#modalOk").on("click", function () {
    var action = $(this).attr("data-action");
    if (action === "cancel") {
      $("#myModal").fadeOut(150);
      return;
    }
    if (
      action === "register" &&
      (!$("#password").val() || $("#password").val() == "")
    ) {
      $("#password").addClass("error-input");
      showToast("Please enter your password");
      return;
    }
    $("#myModal").fadeOut(150);
    $("#submitBtn").prop("disabled", true).html("Submitting...");
    $("#cancelBtn").prop("disabled", true);
    submitForm();
  });
  function submitForm() {
    // 获取表单数据
    var formData = new FormData();
    $.each(filesList, function (i, file) {
      formData.append("files", file);
    });
    formData.append("salePlatformId", $("#formSelect").val());
    formData.append("saleOrder", $("#order_id").val());
    formData.append("userEmail", $("#email").val());
    formData.append("materialSn", $("#serial_number").val());
    formData.append("firstName", $("#frist_name").val());
    formData.append("lastName", $("#last_name").val());
    formData.append("cellPhone", $("#cell_phone").val());
    formData.append("country", $("#country_region").val());
    formData.append("reMarks", $("#remark").val());
    if ($("#password").val()) {
      const encrypted = CryptoJS.AES.encrypt(
        $("#password").val(),
        passwordkey
      ).toString();
      formData.append("userPwd", encrypted);
    }
    // 构造JSONP元数据
    const meta = {
      files: Array.from(filesList).map((f) => f.name),
      callback: "handleUploadResponse",
    };
    formData.append("meta", `jsonpCallback(${JSON.stringify(meta)})`);
    $("#submitBtn").prop("disabled", true).html("Submitting...");
    $("#cancelBtn").prop("disabled", true);
    $("#createAccount").html("");
    showFullscreenLoading();
    if (submitBoolen) {
      return showToast("Requesting...");
    }
    submitBoolen = true;
    // 发送请求
    $.ajax({
      url: host + "/addPlatform",
      method: "POST",
      processData: false,
      contentType: false,
      data: formData,
      success: function (res) {
        if (res.Code == 0) {
          showToast("Submit success");
          setCookie("_sylvoxUserEmail", $("#email").val(), 1);
          var successUrl = `https://sylvoxtv.${netAddress[addressTag]}/`;
          if ($("#modalOk").attr("successUrl")) {
            successUrl = `https://sylvoxtv.${netAddress[addressTag]}` + $("#modalOk").attr("successUrl");
          }
          setTimeout(function () {
            window.location.href = successUrl;
          }, 200);
        } else {
          showToast(res.Msg);
        }
      },
      error: function (xhr) {
        showToast("Submit failed");
      },
      complete: function () {
        $("#createAccount").html("");
        $("#ModalText").html("");
        $("#modalOk").attr("data-action", "");
        $("#submitBtn").prop("disabled", false).html("Submit");
        $("#cancelBtn").prop("disabled", false);
        hideFullscreenLoading();
        submitBoolen = false;
      },
    });
  }
  $("#modalClose").on("click", function () {
    $("#myModal").fadeOut(150);
    setTimeout(function () {
      $("#createAccount").html("");
      $("#ModalText").html("");
    }, 150);
  });
  // 产品序列号上传图片
  $("#scanSerialBtn").on("click", function () {
    $("#serialImgInput").click();
  });
  // JSONP回调函数
  function handleUploadResponse(data) {
    if (data.status === "success") {
      return data.data;
    }
  }
  // 选择图片后触发接口并返回结果显示
  $("#serialImgInput").on("change", function (e) {
    if (!e.target.files || !e.target.files[0]) return;
    $("#serialInputLoading").show();
    $("#serialInputLoading").addClass("input-loading-show");
    $("#serial_number").prop("disabled", true);
    var file = $("#serialImgInput")[0].files[0];
    var formData = new FormData();
    formData.append("file", file);
    formData.append("isSn", true);
    // 构造JSONP元数据
    const meta = {
      file: file.name,
      callback: "handleUploadResponse",
    };
    formData.append("meta", `jsonpCallback(${JSON.stringify(meta)})`);
    $("#serial_number").val("");
    $.ajax({
      url: host + "/uploadfile",
      method: "POST",
      processData: false,
      contentType: false,
      data: formData,
      success: function (res) {
        if (res.Code == 0) {
          $("#serial_number").val(res.data);
          removeClass("#serial_number", "SerialNumber");
        } else {
          showToast(res.Msg);
        }
      },
      error: function (error) {
        $("#serial_number").val("");
        showToast("Error Failed");
      },
      complete: function () {
        $("#serialInputLoading").hide();
        $("#serialInputLoading").removeClass("input-loading-show");
        $("#serial_number").prop("disabled", false);
      },
    });
  });
  // 文本域字数统计
  $("#remark").on("input", function () {
    var len = $(this).val().length;
    $("#descCounter").text(len + "/2000");
  });
  // Toast 提示框
  function showToast(msg, duration) {
    duration = duration || 2000;
    var $toast = $("#globalToast");
    $toast.text(msg).addClass("show");
    clearTimeout($toast.data("timer"));
    var timer = setTimeout(function () {
      $toast.removeClass("show");
    }, duration);
    $toast.data("timer", timer);
  }
  function showFullscreenLoading() {
    $(".loader-content").find('#loader-text').css('display','none');
    let contentText = '<p class="loader-text" style="margin:0;">We will review the submitted information as soon as possible...</p>'
    $(".loader-content").append(contentText);
    PageLoader.show();
  }
  function hideFullscreenLoading() {
    $(".loader-content").find('#loader-text').css('display','block');
    $(".loader-content .loader-text").remove();
    PageLoader.hide();
  }
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name + "=" + encodeURIComponent(value) + expires + "; path=/";
  }
  const $select = $(".el-select");
  const $input = $select.find(".el-select__input");
  const $editor = $select.find(".el-select__editor");
  const $dropdown = $select.find(".el-select__dropdown");
  const $arrow = $select.find(".el-select__arrow");
  const $list = $select.find(".el-select__list");

  // 展开/收起下拉框
  $input.on("click", function (e) {
    e.stopPropagation();
    if (e.target === $editor[0]) return;
    toggleDropdown();
  });

  // 编辑器获取焦点时自动展开
  $editor.on("focus", function () {
    if (!$dropdown.hasClass("el-select__dropdown--visible")) {
      toggleDropdown(true);
    }
  });

  // 输入内容时过滤选项
  $editor.on("input", function () {
    const keyword = $(this).val().toLowerCase();
    $list.empty();
    const filtered = selectList.filter((item) =>
      item.platformUSName.toLowerCase().includes(keyword)
    );
    if (filtered.length === 0) {
      $list.append('<li style="color:#999;text-align:center;">No Matched</li>');
      return;
    }
    filtered.forEach((item) => {
      $list.append(
        `<li class="el-select__item" data-value="${item.id}">${item.platformUSName}</li>`
      );
    });
  });

  // 选择选项
  $list.on("click", ".el-select__item", function () {
    const $item = $(this);
    const value = $item.data("value");
    if (!value) return;
    $("#formSelect").val(value);
    removeClass(".el-select__input", "PurchaseChannel");
    const text = $item.text();
    $editor.val(text);
    $list.find(".el-select__item").removeClass("el-select__item--selected");
    $item.addClass("el-select__item--selected");
    toggleDropdown(false);
    // 触发change事件
    $select.trigger("change", { value, text });
  });

  // 点击页面其他区域收起下拉框
  $(document).on("click", function (e) {
    if (!$editor.val() && $("#formSelect").val() !== '') {
      const value = $("#formSelect").val();
      const text = selectList.filter((item) => item.id == value);
      $editor.val(text[0].platformUSName);
    }

    if (!$dropdown.hasClass("el-select__dropdown--visible")) return;
    toggleDropdown(false, "body");
  });

  function toggleDropdown(show, type) {
    const isVisible =
      typeof show === "boolean"
        ? !show
        : $dropdown.hasClass("el-select__dropdown--visible");
    $dropdown.toggleClass("el-select__dropdown--visible");
    $input.toggleClass("el-select__input--focus");
    $arrow.css("transform", isVisible ? "rotate(0deg)" : "rotate(180deg)");
  }
});
